<script>
  import { onMount, createEventDispatcher } from 'svelte';
  import PopupSocialEmbed from './PopupSocialEmbed.svelte';
  import Video from './Video.svelte';

  export let url;
  export let platform;
  export let content;
  export let width = '100%';
  export let height = 'auto';
  export let title;
  export let textColor = '#ffffff';
  export let hasDescription = false;
  export let altText = '';
  const dispatch = createEventDispatcher();

  function handleClose() {
    dispatch('close');
  }

  onMount(() => {
    dispatch('open');
  });
</script>

{#if content?.videoAssets?.length}
  <Video
    {content}
    {hasDescription}
    {textColor}
    {altText}
    on:close={handleClose}
  />
{:else if url && platform}
  <PopupSocialEmbed
    {url}
    {platform}
    {width}
    {height}
    {title}
    {textColor}
    {altText}
    on:close={handleClose}
  />
{/if}
